<template>
  <div class="function-block">
    <h3 class="function-block__title">{{ $t('view.flow.block.function.title') }}</h3>
    <sel class="function-block__select" v-model="val.function" :label="$t('view.flow.block.function.label')" @change="onInput">
      <option :value="null">-</option>
      <option v-for="fun in this.$store.state.functions" :key="fun" :value="fun">{{ fun }}</option>
    </sel>
  </div>
</template>

<script>
export default {
  data () {
    return {
      val: null
    }
  },
  props: ['value', 'blockId'],
  created () {
    this.val = this.value
  },
  methods: {
    onInput () {
      this.$emit('input', this.val)
      this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
      this.$store.commit('SET_EDITED', true)
    }
  },
}
</script>

<style lang="scss" scoped>
.function-block {
  @include flowElementShadow();
  width: 30%;
  background-color: white;
  border-radius: 7px;
  padding: 1px 14px 10px 14px;
  text-align: left;

  &__title{
    margin: 9px 0 12px 0;
  }
}
</style>
